/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const listNotificationsQueryPageDefault = 1;export const listNotificationsQueryPageSizeDefault = 20;export const listNotificationsQueryUnreadOnlyDefault = false;

export const listNotificationsQueryParams = zod.object({
  "page": zod.number().default(listNotificationsQueryPageDefault),
  "pageSize": zod.number().default(listNotificationsQueryPageSizeDefault),
  "unreadOnly": zod.boolean().optional()
})

export const listNotificationsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().uuid(),
  "typeKey": zod.string(),
  "title": zod.string(),
  "message": zod.string(),
  "subjectId": zod.string().uuid().nullish(),
  "isRead": zod.boolean(),
  "createdDate": zod.string().datetime({})
})),
  "totalCount": zod.number(),
  "page": zod.number(),
  "pageSize": zod.number(),
  "totalPages": zod.number(),
  "hasNextPage": zod.boolean(),
  "hasPreviousPage": zod.boolean()
})

export const getNotificationCountsResponse = zod.object({
  "unreadCount": zod.number(),
  "totalCount": zod.number()
})

export const markNotificationReadParams = zod.object({
  "id": zod.string().uuid()
})

export const markNotificationReadResponse = zod.object({
  "id": zod.string().uuid(),
  "typeKey": zod.string(),
  "title": zod.string(),
  "message": zod.string(),
  "subjectId": zod.string().uuid().nullish(),
  "isRead": zod.boolean(),
  "createdDate": zod.string().datetime({})
})

export const markNotificationUnreadParams = zod.object({
  "id": zod.string().uuid()
})

export const markNotificationUnreadResponse = zod.object({
  "id": zod.string().uuid(),
  "typeKey": zod.string(),
  "title": zod.string(),
  "message": zod.string(),
  "subjectId": zod.string().uuid().nullish(),
  "isRead": zod.boolean(),
  "createdDate": zod.string().datetime({})
})

export const markNotificationsReadBody = zod.object({
  "notificationIds": zod.array(zod.string().uuid())
})

export const markNotificationsReadResponse = zod.object({
  "markedCount": zod.number()
})

export const markNotificationsUnreadBody = zod.object({
  "notificationIds": zod.array(zod.string().uuid())
})

export const markNotificationsUnreadResponse = zod.object({
  "markedCount": zod.number()
})

export const markAllNotificationsReadResponse = zod.object({
  "markedCount": zod.number()
})

export const markAllNotificationsUnreadResponse = zod.object({
  "markedCount": zod.number()
})

export const deleteNotificationsBody = zod.object({
  "notificationIds": zod.array(zod.string().uuid())
})

export const deleteNotificationsResponse = zod.object({
  "deletedCount": zod.number()
})

export const deleteAllNotificationsQueryUnreadOnlyDefault = false;

export const deleteAllNotificationsQueryParams = zod.object({
  "unreadOnly": zod.boolean().optional()
})

export const deleteAllNotificationsResponse = zod.object({
  "deletedCount": zod.number()
})

